import i18n from 'src/i18n'
import ModalBody from 'src/components/Modal/body'
import { useModal } from 'src/hook/useModal'

import { useCallback } from 'react'
import { SchedulePostList } from '../SchedulePostList'
import SchedulePostModalFooter from './schedulePostModalFooter'
import SchedulePostModalHeader from './schedulePostModalHeader'
import SchedulePostModalForm from './schedulePostModalForm'

type SchedulePostModalListProps = {
  formId: string
  formIsInvalid: boolean
  isLoadingScheduledPosts: boolean
  scheduledPostsReqHasError: boolean
  isScheduleFormSaved: boolean
  handleGoBack: () => void
  handleShowList: () => void
  handleClear: () => void
  handleSubmit: () => void
  hasScheduledPosts?: boolean
}

const SchedulePostModalList = ({
  formId,
  formIsInvalid,
  isLoadingScheduledPosts,
  scheduledPostsReqHasError,
  isScheduleFormSaved,
  handleGoBack,
  handleShowList,
  handleClear,
  handleSubmit,
  hasScheduledPosts
}: SchedulePostModalListProps) => {
  const { setModalContent } = useModal()

  const handleShowForm = useCallback(
    () =>
      setModalContent(
        <SchedulePostModalForm
          formId={formId}
          formIsInvalid={formIsInvalid}
          isLoadingScheduledPosts={isLoadingScheduledPosts}
          scheduledPostsReqHasError={scheduledPostsReqHasError}
          isScheduleFormSaved={isScheduleFormSaved}
          handleGoBack={handleGoBack}
          handleShowList={handleShowList}
          handleClear={handleClear}
          handleSubmit={handleSubmit}
          hasScheduledPosts={hasScheduledPosts}
        />
      ),
    [
      formId,
      formIsInvalid,
      isLoadingScheduledPosts,
      scheduledPostsReqHasError,
      isScheduleFormSaved,
      handleGoBack,
      handleShowList,
      handleClear,
      handleSubmit,
      hasScheduledPosts
    ]
  )

  return (
    <>
      <SchedulePostModalHeader
        label={i18n.t('modals.scheduled_posts.title')}
        isStrong={false}
        handleGoBack={handleGoBack}
      />
      <ModalBody className="_px-5 _pb-5 _pt-0 _text-break">
        <SchedulePostList />
      </ModalBody>

      <SchedulePostModalFooter
        isDisabledClearForm
        handleGoBack={handleShowForm}
        shouldShowSubmitBtn={false}
      />
    </>
  )
}

export default SchedulePostModalList
